import moment from "moment";
import TooltipComponent from "@/components/global/tooltip-component.vue";
import RegistrationsChangeStatus from "@/components/registrations/registrations-table/actions/registrations-change-status.vue";
import RegistrationsChangePassword from "@/components/registrations/registrations-table/actions/registrations-change-password.vue";
import { getProtocolColor } from "@/Mixins/registrations/protocolColorMixin";
import { getFormatedDate } from "@/Mixins/dateFormatMixin";
import { getStatusColorReg } from "@/Mixins/registrations/statusMixin";
import { mapActions, mapGetters } from "vuex";
import * as constants from "@/config/constants";
import pgwyClient from "@/api/pgwyClient";

export default {
  components: {
    TooltipComponent,
    RegistrationsChangeStatus,
    RegistrationsChangePassword,
  },
  mixins: [getProtocolColor, getFormatedDate, getStatusColorReg],
  props: ["currentDevice", "fullView"],
  data() {
    return {
      dateFormat: "dddd, Do MMMM YYYY [at] hh:mm [CET]",
      show: false,
      validity_duration: "",
      validityType: "",
      change_pass: {
        changePass: false,
        changePassword: false,
        changePasswordLoader: false,
        valid: false,
        new_pass: {
          newPass: null,
          newPassRules: [(v) => !!v || "New password is required"],
          showNewPass: false,
        },
        confirm_pass: {
          confirmPass: null,
          confirmPassRules: [
            (v) => !!v || "Confirm new password is required",
            (v) =>
              this.change_pass.new_pass.newPass === v || "New Passwords do not match",
          ],
          showConfirmPass: false,
        },
      },
      status_object: {
        switchStatus: true,
        changeStatus: false,
        changeStatusLoader: false,
      },
      generalItems: [
        { title: "Protocol", id: 1 },
        { title: "Registering officer", id: 2 },
        { title: "FQDN", id: 3 },
        { title: "Creation date", id: 4 },
      ],
      extraItems: {
        scep: [
          { title: "IP address", id: 1 },
          { title: "Email address", id: 2 },
        ],
        est: [
          { title: "Subject common name", id: 1 },
          { title: "Auth certificate ca", id: 2 },
        ],
      },
    };
  },
  computed: {
    constants() {
      return constants
    },
    ...mapGetters(["getRegistrationSearchParams", "getRoles"]),
    devices() {
      return [
        { key: "Regid", value: this.currentDevice.regid },
        { key: "Regtype", value: this.currentDevice.regtype },
        { key: "Officer", value: this.currentDevice.officer },
        { key: "Creation date", value: this.currentDevice.creationdate },
        { key: "Status", value: this.currentDevice.status },
        { key: "Validity", value: this.currentDevice.validity },
        { key: "FQDN", value: this.currentDevice.fqdn },
      ];
    },
    popupHeight() {
      if (this.fullView) {
        return "100%";
      } else {
        return "90%";
      }
    },
    size() {
      const size = {
        xs: "small",
        sm: "small",
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
  },
  methods: {
    ...mapActions(["updateRegistrations"]),
    hasRoles(roles) {
      return roles.every((role) => this.getRoles.includes(role));
    },
    statusSwitchClicked() {
      this.status_object.changeStatusLoader = false;
      this.status_object.changeStatus = true;
    },
    closeDialog() {
      this.$emit("closeDialog");
      this.getCurrStatus();
      this.clearStatusVals();
      this.clearPassVals();
    },
    changeView() {
      this.$emit("changeView");
    },
    getValidTo(val1, val2) {
      const formatTemplate = "dddd, Do MMMM YYYY [at] hh:mm [CET]";
      const addValidity = moment(val2).add(val1, "d");
      const finalValue = addValidity.format(formatTemplate);
      return finalValue;
    },
    getCurrStatus() {
      const status = this.currentDevice.status;
      return status === "open"
        ? (this.status_object.switchStatus = true)
        : status === "closed"
          ? (this.status_object.switchStatus = false)
          : "";
    },
    clearStatusVals() {
      const status = this.currentDevice.status;

      this.status_object.changeStatus = false;
      this.validityType = "";
      return status === "open"
        ? (this.status_object.switchStatus = true)
        : status === "closed"
          ? (this.status_object.switchStatus = false)
          : "";
    },
    clearPassVals() {
      this.change_pass.changePassword = false;
      this.change_pass.new_pass.newPass = null;
      this.change_pass.confirm_pass.confirmPass = null;
    },
    changePasswordFunction({ password, device }) {
      if (
        this.change_pass.new_pass.newPass === this.change_pass.confirm_pass.confirmPass
      ) {
        this.change_pass.changePasswordLoader = true;
        let params = {
          regid: device.regid,
          password: password,
        };
        pgwyClient
          .updateRegistration(this.getRegistrationSearchParams.procid, device.regtype, params)
          .then(() => {
            this.change_pass.changePasswordLoader = false;
            this.change_pass.changePassword = false;
            this.$emit("actionResponse", { success: true });
            this.$emit("toolbarUpdate", "password")
            this.updateRegistrations();
          })
          .catch((err) => {
            this.change_pass.changePasswordLoader = false;
            this.$emit("actionResponse", { message: err.response?.data?.msg || "Could not update password" });
          });
      } else {
        this.$emit("actionResponse", { message: "Passwords must match" });
      }
    },
    changeStatusFunction({ status, validity, device }) {
      this.status_object.changeStatusLoader = true;
      let params = {
        regid: this.currentDevice.regid,
        status,
        validity,
      };

      if (this.validityType === "2") {
        params.validity = "always";
      }
      pgwyClient.updateRegistration(this.getRegistrationSearchParams.procid, this.currentDevice.regtype, params)
        .then(() => {
          this.validity_duration = "";
          this.status_object.changeStatusLoader = false;
          this.closeDialog();
          this.validityType = "";
          this.$emit("actionResponse", { success: true });
          this.$emit("toolbarUpdate", "status")
          this.updateRegistrations();
        })
        .catch((err) => {
          this.status_object.changeStatusLoader = false;
          this.$emit("actionResponse", { message: err.response?.data?.msg || "Could not update registration" });
        });
    },
  },
};